module.exports = __webpack_public_path__ + "img/step-11.20604b43.jpg";